import _ from 'underscore';

export function locationRecommendationConverter({ data }) {
  const convertLocation = (location) => {
    let Type = 'Location';
    let CriterionKey = 'LocationCriterion';
    if (!_.isFinite(location.LocationId)) {
      Type = 'Radius';
      CriterionKey = 'RadiusCriterion';
    }
    return {
      Criterion: {
        [CriterionKey]: {
          Name: location.ExpandedName,
          NameTypeCombo: location.ExpandedName,
          ...location,
        },
        Type,
        BidAdjustment: 0,
        Status: 'Active',
      },
      CriterionType: Type,
    };
  };
  return {
    ...data,
    value: _.map(data.value, item => ({
      ...item,
      Id: -parseInt(_.uniqueId(), 10),
      isRecommendedLocation: true,
      Campaign: {
        Id: item.Target.CampaignId,
        Name: item.Target.CampaignName,
      },
      ...convertLocation(item.Location),
    })),
  };
}
